import { render } from "./MonitorsListItem.vue?vue&type=template&id=5dca8365&scoped=true"
import script from "./MonitorsListItem.vue?vue&type=script&lang=js"
export * from "./MonitorsListItem.vue?vue&type=script&lang=js"

import "./MonitorsListItem.vue?vue&type=style&index=0&id=5dca8365&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dca8365"]])

export default __exports__